import { render, staticRenderFns } from "./nullPlate.vue?vue&type=template&id=ca994252&scoped=true&"
import script from "./nullPlate.vue?vue&type=script&lang=js&"
export * from "./nullPlate.vue?vue&type=script&lang=js&"
import style0 from "./nullPlate.vue?vue&type=style&index=0&id=ca994252&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca994252",
  null
  
)

export default component.exports